export enum ConferenceType {
  NONE,
  FACE_TIME,
  TEAMS,
  ZOOM,
  WEB_EX,
}
